import React, { useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Upload, X, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthConfig = () => {
  // Correctif B7 : le cookie httpOnly porte la session, plus d'en-tete Authorization.
  return {
    withCredentials: true,
    headers: {},
  };
};

const ImageUploader = ({ value, onChange, label = "Cliquez pour uploader", aspect = 'square', className = '' }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const aspectClass = {
    square: 'aspect-square',
    video: 'aspect-video',
    wide: 'aspect-[3/1]',
  }[aspect];

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.error('Selectionnez une image'); return; }
    if (file.size > 10 * 1024 * 1024) { toast.error('Image trop volumineuse (max 10 MB)'); return; }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const cfg = getAuthConfig();
      const res = await axios.post(`${API_URL}/api/upload/image`, formData, {
        ...cfg,
        headers: { ...cfg.headers, 'Content-Type': 'multipart/form-data' },
      });
      onChange(res.data.url);
      toast.success('Image uploadee');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur upload');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const handleRemove = (e) => { e.stopPropagation(); onChange(null); };

  return (
    <div className={className}>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
      {value ? (
        <div className={`relative ${aspectClass} rounded-xl overflow-hidden border border-[#E2E8F0] group cursor-pointer`} onClick={() => inputRef.current?.click()}>
          <img src={value} alt="Upload" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center gap-2">
            <span className="text-white text-sm bg-black/60 px-3 py-1.5 rounded-full">Changer</span>
            <button type="button" onClick={handleRemove} className="bg-red-500 hover:bg-red-600 text-white p-1.5 rounded-full">
              <X className="w-4 h-4" />
            </button>
          </div>
          {uploading && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <Loader2 className="w-6 h-6 text-white animate-spin" />
            </div>
          )}
        </div>
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading} className={`w-full ${aspectClass} rounded-xl border-2 border-dashed border-[#E2E8F0] hover:border-[#0596DE] hover:bg-[#F0F9FF] transition flex flex-col items-center justify-center gap-2 text-[#64748B] hover:text-[#0596DE] disabled:opacity-50`}>
          {uploading ? (
            <><Loader2 className="w-8 h-8 animate-spin" /><span className="text-sm">Upload en cours...</span></>
          ) : (
            <><Upload className="w-8 h-8" /><span className="text-sm font-medium">{label}</span><span className="text-xs">JPG, PNG, WebP — max 10 MB</span></>
          )}
        </button>
      )}
    </div>
  );
};

export default ImageUploader;
